import { create } from "zustand";
export const useSurveyStore = create()((set, get) => ({
    isLoaded: false,
    flags: new Set(),
    payloads: {},
    setSurvey: (data) => set((state) => ({
        ...state,
        ...data,
    })),
}));
